<template>
  <div class="block timeline">
    <h2 v-if="title">{{ title }}</h2>
    <div>
      <div v-for="(time, idx) in times" :key="`time-${idx}`" :style="`--i:${idx + 1};`">
        <h3>{{ time.title }}</h3>
        <p v-html="time.body"></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BlockTimeline',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      content: {
        type: Object,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      title() {
        return this.content?.title || null;
      },
      times() {
        return this.content?.entries || [];
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.block.timeline {
  margin-bottom: 100px;
  h2 {
    position: relative;
    text-align: center;
    opacity: 0;

    animation-name: from-top;
    animation-duration: 1s;
    animation-delay: calc(250ms);
    animation-fill-mode: forwards;
  }

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 930px;
    margin: 0 auto;
    padding: 20px 0;

    & > div {
      position: relative;
      max-width: 50%;
      width: 50%;
      text-align: right;
      padding: 30px 30px;
      opacity: 0;
      transform: translate(0, -5%);

      animation-name: from-top;
      animation-duration: 1s;
      animation-delay: calc(250ms + (var(--i) * 250ms));
      animation-fill-mode: forwards;

      &:after {
        position: absolute;
        content: '';
        top: 0;
        right: 0;
        height: 100%;
        width: 1px;
        background-color: #aaa;
      }

      &:first-of-type:after {
        background: linear-gradient(180deg, transparent 0%, #aaa 60%);
      }

      &:last-of-type:after {
        background: linear-gradient(0deg, transparent 50%, #aaa 90%);
      }

      h3 {
        position: relative;
        &:after {
          position: absolute;
          content: '';
          width: 11px;
          height: 11px;
          border-radius: 100%;
          background-color: black;
          right: -35px;
          top: 50%;
          transform: translate(0, -50%);
          transition: transform 0.15s ease;
          z-index: 2;
        }
      }

      &:nth-child(even) {
        text-align: left;
        align-self: flex-end;

        h3 {
          &:after {
            right: auto;
            left: -36px;
          }
        }

        &:after {
          right: auto;
          left: -1px;
        }
      }

      &:hover {
        h3:after {
          transform: translate(0, -50%) scale(1.2);
        }
      }
    }
  }
}
</style>
